import { render, staticRenderFns } from "./detailBusinessApply.vue?vue&type=template&id=9f2a96a2&scoped=true&"
import script from "./detailBusinessApply.vue?vue&type=script&lang=js&"
export * from "./detailBusinessApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2a96a2",
  null
  
)

export default component.exports